import { appReducer, IAppState } from './app/app-reducer';
import { operationsReducer, IOperationsState } from './operations/operations-reducer';
import { omjsReducer, IOmjsState } from './omjs/omjs-reducer';
import { favoritesReducer, IFavoritesState } from './favorites/favorites-reducer';
import { searchReducer, ISearchReducerState } from './search/search-reducer';

export interface IState {
    app: IAppState;
    operations: IOperationsState;
    omjs: IOmjsState;
    favorites: IFavoritesState;
    search: ISearchReducerState;
}

export type Reducers = {
    [Key in keyof IState]: (
        state: IState[Key],
        action: any
    ) => IState[Key];
};

export const reducers: Reducers = {
    app: appReducer,
    operations: operationsReducer,
    omjs: omjsReducer,
    favorites: favoritesReducer,
    search: searchReducer
};
